<template lang='haml'>
  %v-layout.row
    %v-flex.xs12
      %h1 Settings
</template>

<script>
  export default {
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?437a74f0